angular.module('zc.projects')

.directive 'zcCampaignInterestWidgetDeliveryGraph', ($q, $translate, BaseCampaignInterestWidgetGraph, Chart) ->
  class Graph extends BaseCampaignInterestWidgetGraph
    link: (scope, element, attrs) ->
      addYAxis = ->
        scope.chartConfig.options.yAxis = [
          min: 0
          labels:
            formatter: ->
              Highcharts.numberFormat(this.value, 0) + $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.session')
          title:
            text: null
        ,
          min: 0
          labels:
            formatter: ->
              Highcharts.numberFormat(this.value, 2) + '%'
          title:
            text: null
          opposite: true
        ]

      addSeries = (delivery_count_stats, delivery_rate_stats) ->
        scope.chartConfig.series = [
          type: 'column'
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.sessionCount')
          data: delivery_count_stats
          tooltip:
            valueSuffix: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.session')
            valueDecimals: 0
          yAxis: 0
        ,
          type: 'line'
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetDeliveryGraph.distributionRatio')
          data: delivery_rate_stats
          tooltip:
            valueSuffix: '%'
            valueDecimals: 2
          yAxis: 1
        ]

      scope.getStats = =>
        $q.all [
          scope.getCampaignEventStats(@start_event_name)
          scope.getAccessStats()
        ]

      scope.getChartConfig = ->
        scope.chartConfig = Chart.getChartConfig 'line',
          options:
            legend: false

      scope.addChartConfig = ([campaign_event_stats, access_stats]) ->
        session_count_by_start_at = {}
        for stats in access_stats
          start_at = stats.start_at.valueOf()
          session_count_by_start_at[start_at] = stats.session_count
        delivery_count_stats = []
        delivery_rate_stats = []
        for stats in campaign_event_stats
          start_at = stats.start_at.valueOf()
          session_count = session_count_by_start_at[start_at]
          continue unless session_count
          delivery_rate = if session_count then stats.count / session_count * 100 else 0
          delivery_count_stats.push [start_at, stats.count]
          delivery_rate_stats.push [start_at, delivery_rate]
        addYAxis()
        addSeries(delivery_count_stats, delivery_rate_stats)

  return new Graph('daily').createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_interest_widget_delivery_graph.coffee